import type { SortValue } from './types';

export const SORT_OPTIONS: { value: SortValue; label: string }[] = [
  {
    value: 'LATEST',
    label: '최근등록순',
  },
  {
    value: 'POPULAR',
    label: '인기순',
  },
  {
    value: 'REVIEW_COUNT',
    label: '후기 많은순',
  },
];
